import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ClassifiedAds from './index';
import ClassifiedAdDetail from './detail';

export default (
  <Route path="/homepage/classificados">
    <Switch>
      <Route exact path="/homepage/classificados" component={ClassifiedAds} />
      <Route path="/homepage/classificados/:id" component={ClassifiedAdDetail} />
    </Switch>
  </Route>
);
